<script lang="ts">
  import { getPageCategory } from '../../pageCategory'
  import type { SerializedHeaderBlock } from '../../types'

  const HEADING_TAGS: Record<number, string> = { 2: 'h2', 3: 'h3', 4: 'h4', 5: 'h5' }

  let { block }: { block: SerializedHeaderBlock } = $props()

  const pageCategory = getPageCategory()
  const tag = $derived(HEADING_TAGS[block.level] ?? 'h2')
  const underlined = $derived(tag === 'h1' || tag === 'h2')
</script>

<svelte:element
  this={tag}
  id="block-{block.id}"
  class={['header-block-heading', {
    '-underlined': underlined,
    '-variant-brand': pageCategory.variant === 'brand',
    '-variant-warning': pageCategory.variant === 'warning',
    '-variant-success': pageCategory.variant === 'success',
  }]}
>
  {block.title}
</svelte:element>

<style>
  .header-block-heading {
    display: block;
    width: fit-content;
    max-width: 100%;
    scroll-margin-top: var(--space-9);
  }

  .header-block-heading.-underlined {
    padding-bottom: var(--space-4);
    border-bottom: var(--border-3) solid transparent;
  }

  .header-block-heading.-underlined.-variant-brand {
    border-bottom-color: var(--color-variant-brand-line);
  }

  .header-block-heading.-underlined.-variant-warning {
    border-bottom-color: var(--color-variant-warning-line);
  }

  .header-block-heading.-underlined.-variant-success {
    border-bottom-color: var(--color-variant-success-line);
  }
</style>
